
// palette predefinita di colori per i tag.
// usata nel modale di creazione/modifica tag.
export const TAG_PALETTE = [
    { name: "Blu",          color: "#2E6DB1" },
    { name: "Verde",        color: "#5F9279" },
    { name: "Giallo-verde", color: "#8FA830" },
    { name: "Viola",        color: "#7C3AED" },
    { name: "Viola scuro",  color: "#714B67" },
    { name: "Rosso",        color: "#E53E3E" },
    { name: "Arancione",    color: "#D97706" },
    { name: "Teal",         color: "#0D9488" },
    { name: "Rosa",         color: "#EC4899" },
    { name: "Indigo",       color: "#4F46E5" },
    { name: "Lime",         color: "#67cf08" },
    { name: "Grigio",       color: "#64748B" },
];

// converte un colore hex (#RRGGBB) nei suoi componenti RGB
function hexToRgb(hex) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return { r, g, b };
}

// genera gli stili inline per un badge/tag a partire dal colore hex.
// replica il pattern CSS esistente
export function getTagStyles(hexColor) {
    if (!hexColor) return {};
    const { r, g, b } = hexToRgb(hexColor);
    return {
        background: `linear-gradient(135deg, rgba(${r},${g},${b},0.1), rgba(${r},${g},${b},0.05))`,
        color: hexColor,
        border: `1px solid rgba(${r},${g},${b},0.2)`,
    };
}


// stili per il placeholder "Nessun tag"
export const UNTAGGED_STYLES = {
    background: "#F7FAFC",
    color: "#A0AEC0",
    border: "1px dashed #CBD5E0",
};
